import { useCallback, useState } from "react";
import "./Register.scss";
import { Button, message } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { logOut, resetAuthError } from "../../../../features/auth/authSlice";
import LogedIn from "./LogedIn";
import {
  SignIn,
  ConfirmModal,
  RegisterOrganization,
  Login,
  ForgetPassword,
} from "../../../../modals";
import {
  organizationLogin,
  organizationRegister,
} from "../../../../features/auth/authActions";
import Utils from "../../../../utils";

export default function Register({ token, width, isMobile, is_searched }) {
  const { isAuthenticated } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [messageApi, contextHolder] = message.useMessage();
  const openMessage = useCallback(
    (type, content) => {
      messageApi.open({
        type: type,
        content: content,
        duration: 3,
      });
    },
    [messageApi]
  );
  const [is_signin_opened, set_is_signin_opened] = useState(false);
  const [is_confirm_modal_opened, set_is_confirm_modal_opened] =
    useState(false);
  const [register_organization, setRegister_organization] = useState(false);
  const [login_organization, setLogin_organization] = useState(
    pathname === "/login" && !isAuthenticated ? true : false
  );
  const [forget_password, setForget_password] = useState(false);

  const openConfirmModal = () => {
    set_is_confirm_modal_opened(true);
  };

  const handleLogOut = () => {
    dispatch(logOut());
    set_is_confirm_modal_opened(false);
  };

  const registerOrganization = (params, cb, formRef) => {
    dispatch(organizationRegister(params))?.then((res) => {
      if (res?.type === "organization_register/fulfilled") {
        openMessage(
          "success",
          res?.payload?.message ||
            "Organization registered successfully. Please wait for admin approval."
        );
        setRegister_organization(false);
        if (typeof cb === "function") {
          cb();
        }
      } else if (res?.type === "organization_register/rejected") {
        Utils.handleFormErrors(res?.payload, {
          formRef,
          onServerError: (msg) => {
            openMessage("error", msg);
            dispatch(resetAuthError());
            setRegister_organization(false);
          },
        });
      }
    });
  };

  const loginOrganization = (params, cb, formRef) => {
    dispatch(organizationLogin(params))?.then((res) => {
      if (res?.type === "organization_login/fulfilled") {
        setLogin_organization(false);
        if (typeof cb === "function") {
          cb();
        }
      } else if (res?.type === "organization_login/rejected") {
        Utils.handleFormErrors(res?.payload, {
          formRef,
          onServerError: (msg) => {
            openMessage("error", msg);
            dispatch(resetAuthError());
            setLogin_organization(false);
          },
        });
      }
    });
  };

  return (
    <>
      {contextHolder}
      <div
        className="register-cont"
        style={
          !is_searched && isMobile
            ? {
                transform: "translate(-20px, -60%)",
              }
            : null
        }>
        {isAuthenticated ? (
          <LogedIn
            token={token}
            isMobile={isMobile}
            openConfirmModal={openConfirmModal}
          />
        ) : (
          <div className="register-cont__btnsWrapper">
            <Button
              type="primary"
              size={width <= 370 ? "small" : isMobile ? "middle" : "large"}
              style={{
                width: width <= 370 ? "55px" : "auto",
              }}
              shape="round"
              onClick={() => {
                set_is_signin_opened(true);
              }}>
              Sign In
            </Button>
          </div>
        )}
        <SignIn
          token={token}
          isOpened={is_signin_opened}
          onCancel={() => {
            set_is_signin_opened(false);
          }}
          setRegister_organization={setRegister_organization}
          setLogin_organization={setLogin_organization}
        />
        <RegisterOrganization
          token={token}
          title={"Register Organization"}
          isOpened={register_organization}
          onCancel={() => {
            setRegister_organization(false);
          }}
          onOk={registerOrganization}
        />
        <Login
          token={token}
          title={"Sign In With Organization"}
          isOpened={login_organization}
          onCancel={() => {
            setLogin_organization(false);
          }}
          onOk={loginOrganization}
          openRegister={() => {
            setRegister_organization(true);
          }}
          openForgetPassword={() => {
            setForget_password(true);
          }}
        />
        <ForgetPassword
          token={token}
          isOpened={forget_password}
          title={"Forgot Password"}
          onCancel={() => {
            setForget_password(false);
          }}
          openLogedInModal={() => {
            setLogin_organization(true);
          }}
        />
        <ConfirmModal
          token={token}
          title={"Are you sure"}
          subTitle={"You want to log out ?"}
          icon={
            <LogoutOutlined
              style={{ fontSize: "24px", transform: "rotate(180deg)" }}
            />
          }
          isOpened={is_confirm_modal_opened}
          onCancel={() => {
            set_is_confirm_modal_opened(false);
          }}
          onOk={() => {
            handleLogOut();
          }}
        />
      </div>
    </>
  );
}
